import * as React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import { App } from './App';

const domNode: HTMLElement | null = document.getElementById('root');

if(domNode !== null){
  const root = createRoot(domNode);

  root.render(
    <React.StrictMode>
      <App></App>
    </React.StrictMode>
  )
}

